import CompletePageComponent from './CompletePageComponent'

export default CompletePageComponent
